// client/src/routes/app/settings/index.tsx — `/app/settings` → SCR-SET-001 · AUTH-004.
//
// UI-003 held this route with a placeholder so the sidebar's „Setări" entry resolved; the area
// is now the layout in `route.tsx` (04 §8.18) and its bare path lands on the first tab.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings/profile' });
  },
});
